import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Switch } from "../../components/ui/switch";
import api, { apiError, notifyChange } from "../../lib/api";
import { toast } from "sonner";
import PatientSelect from "../PatientSelect";

export default function GymModal({ open, onClose }) {
  const [patient, setPatient] = useState(null);
  const [activity, setActivity] = useState("");
  const [amount, setAmount] = useState("");
  const [paid, setPaid] = useState(false);
  const [method, setMethod] = useState("contanti");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!patient) { toast.error("Seleziona un paziente"); return; }
    setSaving(true);
    try {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      await api.post("/gym", {
        patient_id: patient.id, activity, amount: Number(amount) || 0, paid, method, notes,
        date: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`,
        checkin_time: `${pad(now.getHours())}:${pad(now.getMinutes())}`,
      });
      toast.success("Ingresso palestra registrato");
      notifyChange();
      onClose();
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="gym-modal">
        <DialogHeader><DialogTitle className="font-heading text-xl">Check-in palestra</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Paziente *</Label><PatientSelect value={patient} onChange={setPatient} data-testid="gym-patient" /></div>
          <div><Label>Attività</Label><Input data-testid="gym-activity" value={activity} onChange={(e) => setActivity(e.target.value)} placeholder="Es. Circuito riabilitativo" className="rounded-xl" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Importo (€)</Label><Input data-testid="gym-amount" type="number" min="0" step="0.5" value={amount} onChange={(e) => setAmount(e.target.value)} className="rounded-xl" /></div>
            <div>
              <Label>Metodo</Label>
              <Select value={method} onValueChange={setMethod}>
                <SelectTrigger data-testid="gym-method" className="rounded-xl"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="contanti">Contanti</SelectItem>
                  <SelectItem value="carta/POS">Carta/POS</SelectItem>
                  <SelectItem value="bonifico">Bonifico</SelectItem>
                  <SelectItem value="altro">Altro</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Switch data-testid="gym-paid" checked={paid} onCheckedChange={setPaid} />
            <Label>Pagato</Label>
          </div>
          <div><Label>Note</Label><Input data-testid="gym-notes" value={notes} onChange={(e) => setNotes(e.target.value)} className="rounded-xl" /></div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" data-testid="gym-cancel-btn" onClick={onClose} className="rounded-full">Annulla</Button>
          <Button data-testid="gym-save-btn" onClick={save} disabled={saving} className="rounded-full bg-emerald-600 hover:bg-emerald-700">{saving ? "Salvataggio..." : "Registra ingresso"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
